"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var dom_1 = require("../utils/dom");
var Field_1 = __importDefault(require("./Field"));
var logger_1 = require("../utils/logger");
var Radio = function (_super) {
  __extends(Radio, _super);
  function Radio(configuration, form) {
    var _this = _super.call(this) || this;
    _this.configuration = configuration;
    _this.form = form;
    _this._previousValue = '';
    _this.render = function () {
      var _a = _this,
        form = _a.form,
        configuration = _a.configuration;
      var name = configuration.name,
        label = configuration.label,
        options = configuration.options;
      var labelTextNode = dom_1.createElement('span', {}, label || '');
      var labelNode = dom_1.createElement('p', {
        class: 'ef-form-label'
      }, labelTextNode);
      if (!label) {
        labelNode = dom_1.createElement('span', {}, labelTextNode);
      }
      var inputGroupList = dom_1.createElement('div', {
        class: 'ef-form-input-group-list ef-form-group -inline'
      });
      var fragment = document.createDocumentFragment();
      if (!options) {
        logger_1.logWarning("Options is needed for field " + name + " of type " + configuration.type + " but it's missing");
        return null;
      }
      var defaultValue = configuration.defaultValue || '';
      options.forEach(function (_a) {
        var value = _a.code,
          text = _a.text,
          description = _a.description;
        var initialValue = {
          checked: value === defaultValue ? 'checked' : undefined
        };
        var option = dom_1.createElement('input', __assign({
          id: form.settings.id + "-" + configuration.name + "-" + value,
          name: form.settings.id + "-" + configuration.name,
          type: 'radio',
          value: value,
          class: 'check-custom ef-boolean__input'
        }, initialValue));
        form.data[configuration.name] = defaultValue;
        var span = dom_1.createElement('span', {
          for: form.settings.id + "-" + configuration.name + "-" + value,
          class: 'check-toggle ef-boolean__element -radio'
        });
        var optionCustom = dom_1.createElement('label', {
          for: form.settings.id + "-" + configuration.name + "-" + value,
          class: 'ef-boolean__label'
        }, option, span);
        option.addEventListener('change', function (_a) {
          var target = _a.target;
          return __awaiter(_this, void 0, void 0, function () {
            var actualValue, validation;
            return __generator(this, function (_b) {
              switch (_b.label) {
                case 0:
                  actualValue = target.value;
                  if (!this.htmlElement) {
                    return [2];
                  }
                  _super.prototype._executeListeners.call(this, 'change');
                  return [4, _super.prototype.validate.call(this)];
                case 1:
                  validation = _b.sent();
                  form.data[configuration.name] = validation.outcome ? value : null;
                  this._actualValue = value;
                  dom_1.createErrorMessageNodes(errorMessageWrapper, validation.errorList);
                  _super.prototype._executeListeners.call(this, 'validationCompleted');
                  this._previousValue = actualValue;
                  return [2];
              }
            });
          });
        });
        var optionLabel = null;
        if (description) {
          var optionDescription = dom_1.createElement('span', {
            class: 'label-description'
          }, description);
          optionLabel = dom_1.createElement('label', {
            for: form.settings.id + "-" + configuration.name + "-" + value,
            class: 'label-text'
          }, text, optionDescription);
        } else {
          optionLabel = dom_1.createElement('label', {
            for: form.settings.id + "-" + configuration.name + "-" + value,
            class: 'label-text'
          }, text);
        }
        var inputGroup = dom_1.createElement('div', {
          class: 'ef-form-input-group ef-input-w ef-boolean'
        }, optionCustom, optionLabel !== null && optionLabel !== void 0 ? optionLabel : '');
        inputGroupList.appendChild(inputGroup);
      });
      fragment.appendChild(inputGroupList);
      var errorMessageWrapper = dom_1.createElement('div', {
        class: 'ef-form-validation -is-invalid ef-form-error-message'
      });
      _this.htmlElement = dom_1.createElement('div', {
        class: "ef-form-control ef-form-" + configuration.name + "-wrapper\n      ef-form-" + configuration.type + "-wrapper ef-input-w ef-boolean u-s-mb-xs"
      }, labelNode, errorMessageWrapper);
      _this.htmlElement.appendChild(fragment);
      return _this.htmlElement;
    };
    return _this;
  }
  Radio.builder = function (conf, form) {
    return new Radio(conf, form);
  };
  Object.defineProperty(Radio.prototype, "value", {
    get: function () {
      if (!this.htmlElement) {
        return '';
      }
      var checked = this.htmlElement.querySelector('input:checked');
      if (checked) {
        return checked.value;
      }
      return '';
    },
    set: function (value) {
      var _this = this;
      var configuration = this.configuration;
      if (!this.htmlElement) {
        logger_1.logWarning("Invalid value set for radio group " + this.configuration.name + ": " + value);
        return;
      }
      var children = this.htmlElement.querySelectorAll('input');
      children.forEach(function (child) {
        if (child.value === value) {
          child.checked = true;
          _this.form.data[configuration.name] = value;
          _this._actualValue = value;
        } else {
          child.checked = false;
        }
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Radio.prototype, "previousValue", {
    get: function () {
      return this._previousValue;
    },
    enumerable: false,
    configurable: true
  });
  return Radio;
}(Field_1.default);
exports.default = Radio;
Field_1.default.register('radio', Radio.builder);